import { Markdown } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

const TABLE_SAMPLE = [
  "### Quarterly numbers",
  "",
  "| Region | Revenue | Change |",
  "| --- | --- | --- |",
  "| EMEA | 4.2M | +8% |",
  "| APAC | 3.1M | +12% |",
  "| Americas | 5.9M | +3% |",
  "",
  "Inline `code`, **bold**, and a [link](https://aisquare.studio) for the prose defaults.",
].join("\n");

const CODE_SAMPLE = ["```ts", 'export const answer = "copy me";', "```"].join("\n");

export function MarkdownDemo() {
  return (
    <Section
      id="markdown"
      title="Markdown"
      description="The sealed chat markdown renderer. Tables carry the PQA#2641 treatment by default: hairline header underline, row dividers, and a hover-revealed copy-as-TSV button (paste straight into a sheet)."
    >
      <VariantBlock label="GFM table (hover it for the copy button)">
        <div className="w-full max-w-xl">
          <Markdown content={TABLE_SAMPLE} />
        </div>
      </VariantBlock>

      <VariantBlock label="Fenced code (the sibling copy idiom)">
        <div className="w-full max-w-xl">
          <Markdown content={CODE_SAMPLE} />
        </div>
      </VariantBlock>

      <VariantBlock
        label="loading / streaming / empty"
        caption="three distinct answers, in the order a message actually passes through them: the request is out and no tokens have arrived; tokens are arriving, so a caret; and there is no message at all, which is null"
      >
        <div className="grid w-full max-w-3xl grid-cols-1 gap-4 sm:grid-cols-3">
          <div className="rounded-xl border border-border bg-card p-3">
            <p className="mb-2 font-mono text-[11px] uppercase tracking-wider text-muted-foreground">
              loading
            </p>
            <Markdown content="" loading />
          </div>
          <div className="rounded-xl border border-border bg-card p-3">
            <p className="mb-2 font-mono text-[11px] uppercase tracking-wider text-muted-foreground">
              streaming
            </p>
            <Markdown content="The roadmap is three phases: research, a rough" streaming />
          </div>
          <div className="rounded-xl border border-border bg-card p-3">
            <p className="mb-2 font-mono text-[11px] uppercase tracking-wider text-muted-foreground">
              empty
            </p>
            <Markdown content="   " />
            <p className="text-xs italic text-muted-foreground">
              Whitespace-only returns null — render a TypingIndicator for the pre-first-token state
              rather than an empty wrapper.
            </p>
          </div>
        </div>
      </VariantBlock>
    </Section>
  );
}
